import {TabPositionSticky} from '../../../common/presentational/TabPositionSticky';
import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {DAY_OF_WEEK_COLUMN_TITLE_ID} from '../constant';
import {DayOfWeekColumnScrollHeadless} from '../headless/DayOfWeekColumnScrollHeadless';
import {
  DayOfWeekCommonProps,
  DayOfWeekLogProps,
  DayOfWeekReferenceKeyListProps,
} from '../type';
import {DayOfWeekColumn} from './DayOfWeekColumn';
import {DayOfWeekSection} from './DayOfWeekSection';

interface Props extends DayOfWeekCommonProps, DayOfWeekReferenceKeyListProps {
  logProps: DayOfWeekLogProps;
}

export const DayOfWeekLayoutColumn = ({logProps, ...rest}: Props) => {
  const {isMobile, isWebView} = requestContext.requestInfo.display;
  return (
    <>
      {/* 컬럼 타이틀 */}
      <TabPositionSticky
        id={DAY_OF_WEEK_COLUMN_TITLE_ID}
        depth={4}
        isMobile={isMobile}
        isWebView={isWebView}
      >
        <DayOfWeekSection
          className={twMerge(
            'foldable:gap-10pxr',
            'dark:bg-static-mono-black bg-static-mono-white'
          )}
        >
          <DayOfWeekColumn {...rest}>
            {data => <DayOfWeekColumn.Title columnData={data} />}
          </DayOfWeekColumn>
        </DayOfWeekSection>
      </TabPositionSticky>

      {/* 컬럼 아이템 리스트 */}
      <DayOfWeekSection className="relative foldable:gap-10pxr">
        <DayOfWeekColumn {...rest}>
          {(data, referenceKeyIndex) => (
            <DayOfWeekColumnScrollHeadless isMobile={isMobile}>
              {ref => (
                <DayOfWeekColumn.List
                  columnIndex={referenceKeyIndex}
                  columnListRef={ref}
                  columnData={data}
                  logProps={logProps}
                  isMobile={isMobile}
                />
              )}
            </DayOfWeekColumnScrollHeadless>
          )}
        </DayOfWeekColumn>
      </DayOfWeekSection>
    </>
  );
};
